var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bgiOver" }, [
    _c("div", { staticClass: "over over1" }, [
      _c("div", { staticClass: "timeout01" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", {
        staticClass: "timeout02",
        domProps: { innerHTML: _vm._s(_vm.content) }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isConfirm,
              expression: "!isConfirm"
            }
          ],
          staticClass: "okButton",
          on: {
            click: function($event) {
              _vm.okHandler()
            }
          }
        },
        [_vm._v(_vm._s(_vm.okButtonTxt))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isConfirm,
              expression: "isConfirm"
            }
          ],
          staticClass: "cancelButton",
          on: {
            click: function($event) {
              _vm.confirmCancelHandler()
            }
          }
        },
        [_vm._v(_vm._s(_vm.cancelButtonTxt))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isConfirm,
              expression: "isConfirm"
            }
          ],
          staticClass: "confirmButton",
          on: {
            click: function($event) {
              _vm.ConfirmOK()
            }
          }
        },
        [_vm._v(_vm._s(_vm.okButtonTxt))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a198824", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a198824","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeapPopup.vue
// module id = null
// module chunks = 